import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Music2 } from "lucide-react";
import { useCMS } from "@/hooks/useCMS";
import { useLang } from "@/context/LanguageContext";

export function SiteFooter() {
  const { data } = useCMS();
  const { t } = useLang();
  const s = data.settings || {};
  const NAV = [
    { label: t("Home", "Accueil"), to: "/", key: "home" },
    { label: t("Benni & Friends", "Benni et ses amis"), to: "/BenniBooks", key: "benni" },
    { label: t("Events", "Événements"), to: "/Events", key: "events" },
    { label: t("Initiatives", "Initiatives"), to: "/Initiatives", key: "initiatives" },
    ...(s.show_blog_nav !== false ? [{ label: t("Blog", "Blogue"), to: "/Blog", key: "blog" }] : []),
    { label: t("About", "À propos"), to: "/About", key: "about" },
  ];
  const socials = [
    { icon: Instagram, href: s.social_instagram, label: "Instagram" },
    { icon: Facebook, href: s.social_facebook, label: "Facebook" },
    { icon: Youtube, href: s.social_youtube, label: "YouTube" },
    { icon: Music2, href: s.social_tiktok, label: "TikTok" },
  ];
  return (
    <footer className="bg-[#0F172A] text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <p className="font-display font-black italic uppercase text-3xl sm:text-5xl leading-[0.9] break-words">
              #Show<span className="text-[#2CACD4]">Us</span>Your<span className="text-[#DB1A5C]">Moves</span>
            </p>
            <p className="mt-5 max-w-sm text-white/70">
              {s.mission_line || "Making Canada the healthiest nation on earth by 2030"}
            </p>
            <div className="mt-6 flex gap-3">
              {socials.map((so) => (
                <a
                  key={so.label}
                  href={so.href || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={so.label}
                  data-testid={`footer-social-${so.label.toLowerCase()}`}
                  className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 hover:bg-[#2CACD4] hover:text-slate-950 transition-colors cursor-pointer"
                >
                  <so.icon size={19} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="eyebrow mb-4">{t("Explore", "Explorer")}</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-white/70 hover:text-white transition-colors cursor-pointer" data-testid={`footer-nav-${n.key}`}>
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-4">{t("Get in touch", "Nous joindre")}</p>
            <a href={`mailto:${s.contact_email || "info@showusyourmoves.ca"}`} className="text-white/70 hover:text-white transition-colors cursor-pointer block">
              {s.contact_email || "info@showusyourmoves.ca"}
            </a>
            <p className="mt-3 text-white/50 text-sm">{s.location || "Ottawa, ON · Canada"}</p>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/40">
          <p>© {new Date().getFullYear()} {s.copyright || "National Health & Fitness Foundation"}</p>
          <p className="font-semibold text-white/60">#ShowUsYourMoves · #BougeAvecNous</p>
        </div>
      </div>
    </footer>
  );
}
